import { render, staticRenderFns } from "./CampaignsSent.vue?vue&type=template&id=4075ea99&scoped=true"
import script from "./CampaignsSent.vue?vue&type=script&lang=js"
export * from "./CampaignsSent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075ea99",
  null
  
)

export default component.exports